import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

const STYLES = {
  light: {
    box: 'bg-white border-emerald-200 text-emerald-800',
    icon: 'text-emerald-600',
    link: 'text-emerald-700 hover:text-emerald-900',
  },
  onGreen: {
    box: 'bg-white/15 border-white/30 text-white backdrop-blur-sm',
    icon: 'text-emerald-200',
    link: 'text-white/90 hover:text-white',
  },
  dark: {
    box: 'bg-emerald-500/15 border-emerald-400/40 text-white',
    icon: 'text-emerald-400',
    link: 'text-white/70 hover:text-white',
  },
};

export const VendorSpotsFilled = ({ variant = 'light', testId }) => {
  const s = STYLES[variant];
  return (
    <div className="flex flex-col items-start gap-2" data-testid={testId}>
      <div className={`inline-flex items-center gap-2 rounded-full border px-6 py-3 text-lg font-semibold ${s.box}`}>
        <CheckCircle className={`w-5 h-5 ${s.icon}`} />
        All Vendor Spots Have Been Filled!
      </div>
      <Link
        to="/contact?subject=vendor&event=festival-of-trees"
        className={`inline-flex items-center gap-1 text-sm underline underline-offset-4 transition-colors pl-2 ${s.link}`}
        data-testid={`${testId}-waitlist-link`}
      >
        Join the waitlist
        <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
};
